import React from "react";
import { Box, Button, Typography, ToggleButtonGroup, ToggleButton, Chip, Tooltip, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { styles } from "../../styles/Vendors.styles";

const VendorHeader = ({ showArchived, setShowArchived, onAddVendor, hasActiveFilters }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <Typography variant="h5" fontWeight="600" color={theme.customColors.text.strong}>
        Vendors
      </Typography>
      <ToggleButtonGroup
        value={showArchived ? "archived" : "active"}
        exclusive
        onChange={(_, val) => {
          if (val !== null) setShowArchived(val === "archived");
        }}
        size="small"
        sx={{
          borderRadius: "26px",
          border: `1px solid ${theme.customColors.border.main}`,
          overflow: "hidden",
          "& .MuiToggleButton-root": {
            border: "none !important",
            borderRadius: "36px",
            color: theme.customColors.text.secondary,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.75rem",
            px: 3,
            py: 1,
            minWidth: "70px",
            "&.Mui-selected": {
              backgroundColor: theme.customColors.icons.primary,
              color: theme.customColors.button.text,
              "&:hover": {
                backgroundColor: theme.customColors.button.hover,
              },
            },
            "&:hover:not(.Mui-selected)": {
              backgroundColor: theme.customColors.background.header,
              color: theme.customColors.text.strong,
            },
          },
        }}
      >
        <ToggleButton value="active">Active</ToggleButton>
        <ToggleButton value="archived">Archived</ToggleButton>
      </ToggleButtonGroup>
      {hasActiveFilters && (
        <Chip
          label="Filtered"
          size="small"
          color="primary"
          variant="outlined"
          sx={{
            height: 24,
            fontSize: "0.75rem",
            fontWeight: 500,
            color: theme.customColors.text.secondary,
            borderColor: theme.customColors.border.main,
            background: theme.customColors.background.light,
          }}
        />
      )}
      <Box sx={{ flex: 1 }} />
      <Tooltip title="Add a new vendor" arrow>
        <span>
          <Button
            variant="contained"
            startIcon={<AddIcon sx={{ fontSize: 16 }} />}
            onClick={onAddVendor}
            sx={styles.addButton}
          >
            Add Vendor
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default VendorHeader;
